export const INVENTORY_SETTINGS = {
    ADD_PREBOOK_FIELD_BTN: "add-prebook-field-btn",
    SAVE_PREBOOK_FIELDS_BTN: "save_prebook_fields_btn",
    SELECT_PRODUCT_FIELD: "select_product-field",
    ADD_PREBOOK_FIELD_SUBMIT: "add-prebook-field-submit",
    ACTIONS_MENU: "actions-menu",
    ADD_VALUE_ACTION: "add-value-action",
    DELETE_FIELD_ACTION: "delete-action",
    PREBOOK_VALUE_CHIP: "prebook-value-chip",
    PRODUCT_FIELDS_ITEM: "products-fields-item",
    PREBOOK_FIELD_ERROR: "prebook-fields-error",
    PREBOOK_FIELD_OPTION: "prebook-field-option",
    PREBOOK_FIELD_LABEL: "prebook-field-label",
    PREBOOK_FIELDS_CONTAINER: "prebook-fields-container",
    UPDATE_PREFERENCES_BTN: "update-preferences-btn",
};
